jQuery(document)
    .ready(function () {
        $("select").select2({
            tags: false,
            theme:'bootstrap-5'
        });
        /*$("ul.select2-selection__rendered").sortable({
            containment: 'parent'
        });*/

        $('#mobile').mask('999.999.9999', {'translation': {9: {pattern: /[0-9*]/}}});
        $('#phone').mask('999.999.9999', {'translation': {9: {pattern: /[0-9*]/}}});
        $('.toggle-password i')
            .click(function () {
                if ($(this)
                    .hasClass('bi-eye')) {
                    $(this)
                        .removeClass('bi-eye')
                        .addClass('bi-eye-slash');
                    $(this)
                        .parent()
                        .prev('input[type="text"]')
                        .attr('type', 'password');
                } else {
                    $(this)
                        .removeClass('bi-eye-slash')
                        .addClass('bi-eye');
                    $(this)
                        .parent()
                        .prev('input[type="password"]')
                        .attr('type', 'text');
                }
            });

        $(document).on("click",".pricing_btn",function() {
            $.ajax({
                type: 'GET',
                url: '/update-direct-purchase-session-data',
                dataType: 'json',
                data : {'package_id': $(this).attr('data-package_id')},
                success: function (response) {
                    if(response){
                        window.location.href = '/buy';
                    }
                },
                error: function (xhr) {
                    // console.log(xhr);
                }
            });
        });

        $("body").on('keyup', '[name="extra_info[basic][domain]"]', function (e) {
            $(this).val($(this).val().toLowerCase());
        });

        $('#freeTrialFrm').on('submit', function (e) {
            if($('#zipcode').val() == '' || $('#zipcode').val() == undefined ){
                $('#validationZipcodePrependFeedback').addClass('visible');
            } else {
                $('#validationZipcodePrependFeedback').removeClass('visible');
            }
        });
    });
$(function () {
    (function () {
        'use strict';

        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.querySelectorAll('.needs-validation');

        // Loop over them and prevent submission
        Array.prototype.slice.call(forms)
            .forEach(function (form) {
                form.addEventListener('submit', function (event) {
                    form.classList.remove('was-validated');
                    $(form).find('.is-invalid').removeClass('is-invalid');
                    $(form).find('.invalid-feedback').removeClass('d-none');
                    $(form).find('.invalid-feedback-session-error').html('');
                    if (!form.checkValidity()) {
                        event.preventDefault();
                        event.stopPropagation();
                    }

                    form.classList.add('was-validated');
                }, false);
            });
    })();
});

/* var url = '/api/v1/zipcode?term=' + $('#zipcode')
    .val();
var zipcode_suggestions = [];
var Zipcodes = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('zip_code'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    prefetch: url,
    remote: {
        url: '/api/v1/zipcode?term=%QUERY&for=typeahead',
        wildcard: '%QUERY'
    }
});

$('#remote .typeahead').typeahead(null, {
    name: 'zipcode_suggestions',
    displayKey: 'zip_code',
    source: Zipcodes,
    templates: {
        empty: [
            '<div class="empty-message">',
            'Unable to find any zipcode that match the current search',
            '</div>'
        ].join('\n'),
        suggestion: Handlebars.compile('<div title="Zipcode: {{zip_code}} | State: {{state_code}} | County: {{county_name}} | City: {{city_name}} ">' +
            '<span>Zipcode: {{zip_code}}</span> | ' +
            '<span>State: </span>{{state_code}} | ' +
            '<span> County: </span>{{county_name}} | ' +
            '<span> City: </span>{{city_name}}' +
            '</div>')
    }
});

$('.typeahead').bind('typeahead:select', function(ev, suggestion) {
    $('#zipcode').val(suggestion.zip_code);
    $('#county').val(suggestion.county_name);
    $('#state').val(suggestion.state_code);
    $('#city').val(suggestion.city_name);
}); */

$(document).ready(function (e) {
    if (typeof bootstrap !== 'undefined') {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        });
    }
    $("body").on('keyup', '.zipcode_autocomplete', function () {

        var id = $(this).attr('id');
        // console.log($(this).val().length);
        if ($(this).val() != '' && $(this).val().length >= 2) {
            $("#" + id).addClass('ZipcodeLoading');
        }
        var state = $(this).data('state');
        var city = $(this).data('city');
        var county = $(this).data('county');
        var control_type = $(this).data('control_type');
        var mod = $(this).data('mod');
        if (mod == "" || mod == undefined) {
            mod = "";
        }
        if (control_type == "" || control_type == undefined) {
            control_type = "dropdown";
        }

        // $("#" + id).autocomplete({
        //     source: function( request, response ) {
        //         $.ajax({
        //             url: "/api/v1/zipcode?term=" + $("#" + id).val(),
        //             type: 'get',
        //             dataType: "json",
        //             data: {},
        //             success: function( data ) {
        //                 // console.log(data.Data);
        //                 response( data.Data );
        //             }
        //         });
        //     },
        //     select: function (e, ui) {
        //         $(this).val(ui.item.zip_code);
        //
        //         $("#"+county).val(ui.item.county_name);
        //         $("#"+state).val(ui.item.state_code);
        //         $("#"+city).val(ui.item.city_name);
        //         $("#" + id).removeClass('ZipcodeLoading');
        //         return false;
        //     },
        //     close: function (event, ui) {
        //         $("#" + id).removeClass('ZipcodeLoading');
        //         var source = ($(this).val() || "").trim();
        //
        //         var found = $('.ui-autocomplete li').text().search(source);
        //         if (found < 0) {
        //             $(this).val('');
        //
        //         }
        //     }
        // }).autocomplete("instance")._renderItem = function (ul, item) {
        //     // if($("#" + id).hasClass('ZipcodeLoading')) {
        //     $("#" + id).removeClass('ZipcodeLoading');
        //     // }
        //     return $("<li class='list-group-item' style='font-size: 12px'>")
        //         .append("<span><b>Zipcode</b> : " + item.zip_code + "</span> <span><b>State</b> : " + item.state_code + " </span> <span><b>City</b> : " + item.city_name +" </span>")
        //         .appendTo(ul);
        // };
        $("#" + id).autocomplete({
            source: function( request, response ) {
                $.ajax({
                    url: "/api/v1/zipcode?term=" + $("#" + id).val(),
                    type: 'get',
                    dataType: "json",
                    data: {},
                    success: function( data ) {
                        // console.log(data.Data);
                        response( data.Data );
                    }
                });
            },
            select: function (e, ui) {
                $(this).val(ui.item.zip_code);

                $("#"+county).val(ui.item.county_name);
                $("#"+state).val(ui.item.state_code).select2({theme:'bootstrap-5'});

                // $("#"+state).select2().select2(ui.item.state_code);
                // $("#"+state).val(ui.item.state_code);
                $("#"+city).val(ui.item.city_name);
                $("#" + id).removeClass('ZipcodeLoading');
                return false;
            },
            close: function (event, ui) {
                $("#" + id).removeClass('ZipcodeLoading');
                var val = $(this).val();
                var source = val ? String(val).trim() : "";

                var found = $('.ui-autocomplete li').text().search(source);
                if (found < 0) {
                    $(this).val('');

                }
            }
        }).autocomplete("instance")._renderItem = function (ul, item) {
            // if($("#" + id).hasClass('ZipcodeLoading')) {
            $("#" + id).removeClass('ZipcodeLoading');
            // }
            return $("<li class='list-group-item' style='font-size: 12px'>")
                .append("<span><b>Zipcode</b> : " + item.zip_code + "</span> <span><b>State</b> : " + item.state_code + " </span> <span><b>City</b> : " + item.city_name +" </span>")
                .appendTo(ul);
        };

    });
});
